/* eslint-disable no-setter-return */
/* eslint-disable no-dupe-else-if */
/* eslint-disable no-import-assign */
/* eslint-disable no-dupe-else-if */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
	CardLogo, BtnTrash, CardDiv, LogoName, SelectableCard,
} from './style';
import Card from '../Card';
import { ReactComponent as Trash } from '../../../img/trash.svg';
import ModalDeleteLogo from '../ModalDeleteLogo';
import RadioInput from '../RadioInput';

const CardPreviewLogo = ({
		logo,
		handleDelete,
		deleteOption,
		imgWidth,
		imgHeight,
		imgStyles,
		formOption,
		marginTop,
		formOptionLogo,
		setFormOptionLogo,
		setFormOptionName,
}) => {
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const url = logo.attributes.url;
	const logoName = logo.attributes.name;
    const onDelete = () => setDeleteModalOpen(true);

    const renderLogo = () => (
	<>
		{
				deleteOption
				&& (
					<ModalDeleteLogo
						isOpen={deleteModalOpen}
						openAction={setDeleteModalOpen}
						deleteAction={handleDelete}
						logo={logo}
					/>
				)
			}
		<CardDiv marginTop={marginTop}>
			<Card border="1px solid #F0F0F0" noShadow>
				<div className="row">
					<div className="col-12">
						<CardLogo className="d-flex justify-content-center">
							<img
								src={url}
								alt=""
								style={{ width: imgWidth, height: imgHeight, ...imgStyles }}
							/>
							{
									deleteOption
									&& (
										<BtnTrash
											onClick={onDelete}
										><Trash height="12pt" width="12pt" />
										</BtnTrash>
									)
								}
						</CardLogo>
						<LogoName>
							{
									formOption
										? (
											<RadioInput
												type="radio"
												name="logo-radio-option"
												label={logoName || 'Logo sem nome'}
												value={logo.id}
												checked={logo.id === formOptionLogo}
												onClick={() => {
													setFormOptionLogo(logo.id);
													setFormOptionName(logoName || 'Logo sem nome');
												}}
											/>
										)
										: (
											logoName || 'Logo sem nome'
										)
								}
						</LogoName>
					</div>
				</div>
			</Card>
		</CardDiv>
	</>
    );

    const renderSelectableLogo = () => (
	<CardDiv marginTop={marginTop}>
		<SelectableCard
			className={logo.id === formOptionLogo ? 'isSelected logoSelect' : 'logoSelect'}
			onClick={() => {
                setFormOptionName(logo.attributes.name || 'Logo sem nome');
                setFormOptionLogo(logo.id);
            }}
		>
			<div className="row">
				<div className="col-12">
					<CardLogo className="d-flex justify-content-center">
						<img
							src={url}
							alt=""
							style={{ width: imgWidth, height: imgHeight, ...imgStyles }}
						/>
					</CardLogo>
				</div>
			</div>
		</SelectableCard>
	</CardDiv>
    );

	return formOption ? renderSelectableLogo() : renderLogo();
};

CardPreviewLogo.defaultProps = {
	deleteOption: false,
	imgWidth: '100px',
	imgHeight: '100px',
	imgStyles: {},
	formOption: false,
	marginTop: '29px',
	formOptionLogo: '',
	setFormOptionLogo: () => {},
	setFormOptionName: () => {},
};

PropTypes.CardPreviewLogo = {
	logo: PropTypes.object.isRequired,
	handleDelete: PropTypes.func.isRequired,
	deleteOption: PropTypes.boolean,
	imgWidth: PropTypes.string,
	imgHeight: PropTypes.string,
	imgStyles: PropTypes.object,
	formOption: PropTypes.boolean,
	marginTop: PropTypes.string,
	formOptionLogo: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	setFormOptionLogo: PropTypes.func,
	setFormOptionName: PropTypes.func,
};

export default CardPreviewLogo;
